import { Filiale } from './filiale';
import { ModelWithAddressAndContactInfo } from './model-with-address-contact-info';
import { Ruolo } from "./ruolo";
import { Studio } from './studio';


export class User extends ModelWithAddressAndContactInfo {
  static apiUrl: string = "users";
  titolo: string;
  qualifica: string;
  nome: string;
  cognome: string;
  ruoli: Ruolo[];

  studio: Studio;
  studio_id: number;

  filiale: Filiale;
  filiale_id: number;

  compenso_minimo: number;
  compenso_massimo: number;
  compenso_percentuale: number;

  /** In parcella, questo numero viene dato all'accertatore e viene tolto dall'incaricato principale. */
  compenso_accertamenti: number;

  /** Colore primario personalizzato del tema (hex, es. #3f51b5) */
  theme_color?: string;

  /** Path avatar su S3 */
  avatar_path?: string;
  /** URL temporaneo per visualizzare l'avatar */
  avatar_url?: string;

  /** Account collegati (stessa persona in studi diversi) */
  linked_users?: LinkedUser[];
  linked_user_ids?: number[];

  is_ticket_admin: boolean;

  public hasRole(roleName: string) {
    try {
      const searchedRoleName = roleName.toLowerCase().trim();
      return this.ruoli.some(x => x.nome.toLowerCase().trim() == searchedRoleName);
    }
    catch (e) {
      return false;
    }
  }
  
  public hasAnyRole(roleNames: string[]) {
    try {
      return roleNames.some((searchedRole) => this.hasRole(searchedRole));
    }
    catch (e) {
      return false;
    }
  }

  deserialize(input: any): User {
    let retV: User = new User();

    retV = super.deserialize(input) as User;
    if (input) {

      if (input?.ruoli) {
        retV.ruoli = input.ruoli.map(r => new Ruolo().deserialize(r));
      }
      if (input?.studio) {
        retV.studio = new Studio().deserialize(input.studio);
      }
      if (input?.linked_users) {
        retV.linked_users = input.linked_users;
      }

    }
    return retV;
  }


  public isTicketOnly(): boolean {
    return this.is_ticket_admin && !this.studio_id;
  }

  public getHumanIdentifier() {
    if (this.titolo)
      return `${this.titolo} ${this.nome} ${this.cognome}`;
    return `${this.nome} ${this.cognome}`;
  }

}

/** Interfaccia per account collegato (versione semplificata per evitare ricorsione) */
export interface LinkedUser {
  id: number;
  nome: string;
  cognome: string;
  email: string;
  studio_id?: number;
  studio?: {
    id: number;
    nome: string;
  };
}
